module.exports = __webpack_public_path__ + "static/media/gallery29.5f2fda7d.png";